namespace SPA {
	export namespace Contacts {
		interface IContactEditOptions extends Backbone.ViewOptions<SPA.Contact> {
			Status: IContactStatusName;
			ObjectNumber: string;
		}

		export class DetailDisplayView extends Backbone.View<SPA.Contact> {
			private Status: string | undefined;
			private ObjectNumber: string | undefined;
			private Company: Wollmilch.CompanyObject;

			public constructor(options: IContactEditOptions) {
				super(options);
				this.Company = app.getAuthenticationManager().getCompany();
				this.ObjectNumber = options.ObjectNumber;
			}

			public preinitialize(options: IContactEditOptions): void
			{
				this.Status = options.Status;
				this.ObjectNumber = options.ObjectNumber;

				options.tagName = 'div';
				options.events = {
					'click .btn-edit': this.onContactEditClick,
					'click .btn-create': this.onContactCreateClick,
					'click .btn-assign': this.onContactAssignClick,
					'click .btn-replace': this.onContactReplaceClick,
				};
			}

			public initialize(options?: Backbone.ViewOptions): void {
				// Init events
				this.listenTo(this.model, 'change', this.render);
			}

			public render(): DetailDisplayView
			{
				let body: JQuery = $('<div>');
				const email = this.model.Email ? this.model.Email : '---';
				const phone = this.model.Phone ? this.model.Phone : '---';
				const mobile = this.model.Mobile ? this.model.Mobile : '---';

				if (this.model.ContactID === 0) {
					body = $('<p>Kein Kontakt zugewiesen</p>')
						.add(`<div class="actionplane">
							<button class="btn btn-create btn-default"><i class="fas fa-user-plus"></i> Erstellen</button>
							<!-- <button class="btn btn-assign btn-default"><i class="fas fa-users"></i> Zuweisen</button> -->
						</div>`);
				} else {
					body = $(`
					<address>
						<div class="postal">
							${this.model.Salutation ? SPA.types.Salutation[this.model.Salutation as keyof typeof SPA.types.Salutation] : ''} ${this.model.Title}
							${this.model.Name} ${this.model.Surname}<br>
							${this.model.Street} ${this.model.HouseNumber}<br>
							${this.model.PostalCode} ${this.model.City}<br>
							${SPA.types.Address.State[this.model.State as keyof typeof SPA.types.Address.State]}
						</div>
						<div class="contact">
							<i class="fas fa-envelope"></i> <span>${email}</span><br>
							<i class="fas fa-phone"></i> <span>${phone}</span><br>
							<i class="fas fa-mobile"></i> <span>${mobile}</span>
						</div>
					</address>`)
					.add(`<div class="actionplane">
						<button class="btn btn-edit btn-default"><i class="fas fa-user-edit"></i> Bearbeiten</button>
						<!-- <button class="btn btn-replace btn-default"><i class="fas fa-users"></i> Ersetzen</button> -->
					</div>`);
				}

				this.$el.empty().append(body);

				return this;
			}

			private onContactAssignClick(e: JQuery.TriggeredEvent) {
				e.preventDefault();
				alert('Funktion in Bearbeitung');
			}

			private onContactCreateClick(e: JQuery.TriggeredEvent) {
				e.preventDefault();
				const type = SPA.types.Address.Type[this.Status as keyof typeof SPA.types.Address.Type];
				const contactModal = new SPA.Contacts.Modal(this.Company);
				// Set modal title
				contactModal.setTitle('Neuen ' + type + ' anlegen');
				// Build and append the new "customer" form
				contactModal.setObjectNumber(this.ObjectNumber as string);
				contactModal.setType(this.Status as IContactStatusName);
				// contactModal.setPrimaryButtonText('Speichern');
				// show the form
				contactModal.setCallback((data: IContact) => {
					app.getContactManager().link(data.ContactID as number, this.ObjectNumber as string, this.Status as IContactStatusName);
					this.model = data as Contact;
					this.render();
				});
				contactModal.show();
			}

			private onContactEditClick(e: JQuery.TriggeredEvent) {
				e.preventDefault();
				app.getGlobalTabControl().addTab(
					this.model.Surname + ', ' + this.model.Name + ' (' + this.model.ContactID + ')',
					new SPA.Contacts.Detail(this.model),
					true
				);
			}

			private onContactReplaceClick(e: JQuery.TriggeredEvent) {
				e.preventDefault();
				alert('Funktion in Bearbeitung');
			}
		}
	}
}
